console.log("Tabletop Goodies - Script  - Collections");

TTG = function (parent) {
    const result = {};

    const _queueClass = class {
        constructor() {
            this.elements = {};
            this.head = 0;
            this.tail = 0;
        }

        enqueue(element) {
            this.elements[this.tail] = element;
            this.tail++;
        }

        dequeue() {
            const item = this.elements[this.head];
            delete this.elements[this.head];
            this.head++;
            return item;
        }

        dequeueAll() {
            const r = [];
            while (!this.isEmpty) {
                r.push(this.dequeue());
            }
            return r;
        }

        peek() {
            return this.elements[this.head];
        }

        get length() {
            return this.tail - this.head;
        }

        get isEmpty() {
            return this.length === 0;
        }

    }

    result.Queue = _queueClass;

    parent.Collections = result;
    return parent;
}(TTG);